import { Icon, Modal, Text } from 'ab-uitools-legacy'
import { TErrorPopupProps } from './types'
import './index.scss'

const ErrorPopup = (props: TErrorPopupProps) => {
  const { errorMessage, closePopup, configs } = props

  return (
    <Modal
      isOpen={!!errorMessage}
      onClose={closePopup}
      onSumbit={closePopup}
      buttonProps={{ confirm: { buttonText: 'Լավ' } }}
      title={configs.title}
    >
      <div className={`error_popup ${configs.type === 'warning' ? 'warning' : ''}`}>
        {configs.type !== 'warning' && (
          <div className="icon-wrapper">
            <Icon name="close" size="medium" type="danger" />
          </div>
        )}
        <Text className="error_popup_message">{errorMessage}</Text>
      </div>
    </Modal>
  )
}
export default ErrorPopup
